import { Box, IconButton, IconButtonProps } from '@chakra-ui/react';
import SearchInput from '@components/common/SearchInput';
import { useBoolean } from 'hooks/useBoolean';
import { useCallback, useRef } from 'react';
import Search from 'vectors/Search';

interface Props {
  query: string;
  setQuery: (query: string) => void;
  size?: IconButtonProps['size'];
  iconColor?: string;
}
const ExpandableSearchButton = ({ query, setQuery, size = 'sm', iconColor }: Props) => {
  const [isExpanded, setIsExpanded] = useBoolean(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = useCallback(() => {
    setIsExpanded.toggle();
    if (!isExpanded) {
      requestAnimationFrame(() => inputRef.current?.focus());
    }
  }, [setIsExpanded, isExpanded]);

  const handleBlur = useCallback(() => {
    setIsExpanded.off();
  }, [setIsExpanded]);

  return (
    <Box position="relative">
      {isExpanded ? (
        <SearchInput query={query} setQuery={setQuery} size={size} onBlur={handleBlur} autoFocus />
      ) : (
        <IconButton variant="ghost" size={size} borderRadius="md" onClick={handleClick}>
          <Search color={iconColor} />
        </IconButton>
      )}
    </Box>
  );
};

export default ExpandableSearchButton;
